import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useModalStore } from "@store/modal/modal";
import { usePOAModal } from "./usePOAModal";

export const usePowerOfAttorneyAddBillModalSearchParamWatcher = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { create, remove } = useModalStore();

  const { openPOAModal } = usePOAModal();

  const [powerOfAttorneyLedgerConsentId, setPowerOfAttorneyLedgerConsentId] =
    useState<string | undefined>();

  useEffect(() => {
    const powerOfAttorneyLedgerConsentId = searchParams.get(
      "powerOfAttorneyLedgerConsentId",
    );

    if (powerOfAttorneyLedgerConsentId) {
      setPowerOfAttorneyLedgerConsentId(powerOfAttorneyLedgerConsentId);
      setSearchParams(undefined);
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    let id = null;

    if (powerOfAttorneyLedgerConsentId) {
      id = openPOAModal({
        powerOfAttorneyLedgerConsentId: powerOfAttorneyLedgerConsentId,
      });
    }

    return () => (id ? remove(id) : undefined);
  }, [powerOfAttorneyLedgerConsentId, create, remove, openPOAModal]);
};
